
        import 'PeachyLogo.380d726.css-module'
        export default {"PeachyLogo":"PeachyLogo_PeachyLogo_380d726"}
    